
import styled from 'styled-components'
import { COLORS } from 'theme'

export const RecentActivityContainer = styled.div`
  background: #FAFAFB;
  border-radius: 8px;
  margin-top: 18px;
  margin-bottom: 20px;
`

export const Title = styled.h3`
  font-size: 19px;
  font-weight: 700;
  color: ${COLORS.TEXT_HIGH};
  margin-bottom: 18px;
  
`

export const ActivityList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const ActivityItem = styled.li`
  margin-bottom: 6px;
  margin-top: 3px;
  font-size: 15px;
  color: ${COLORS.TEXT_LOW};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  line-height: 1.4;
  padding: 3px 20px;
  gap: 2px;
  
  &:hover {
    background: rgba(0, 0, 0, 0.02);
  }

  &:last-child {
    margin-bottom: 0;
  }

  &:before {
    content: "•";
    color: ${COLORS.TEXT_LOW};
    margin-right: 8px;
  }

  strong {
    font-weight: 600;
    color: ${COLORS.TEXT_HIGH};
  }

  > div:first-child {
    flex: 1;
    min-width: 0;
  }
`

export const DateText = styled.span`
  color: ${COLORS.TEXT_LOW};
  font-size: 12px;
  min-width: 85px;
  text-align: right;
  flex-shrink: 0;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`
